import { Injectable, signal } from "@angular/core"
import { Observable, of } from "rxjs"
import { catchError, tap } from "rxjs/operators"
import { AlarmApiService } from "@api/alarm/alarm-api.service"
import { AlarmSummary } from "@api/alarm/models/alarm-summary"
import { StateService } from "./state.service"

@Injectable()
export class IntegrationStatusService {
  // notificationsEnabled = true;
  integrationErrors: Map<string, Map<string, number>> = Object()
  private readonly alarmSummaries = signal<Record<string, AlarmSummary | null>>({})

  constructor(private alarmApiService: AlarmApiService, private stateService: StateService) {}

  getTotalErrors(hotelId: string): number {
    if (this.integrationErrors[hotelId] === undefined) {
      return 0
    }
    return this.sum(this.integrationErrors[hotelId])
  }
  setTotalErrors(hotelId: string, name: string, value: number) {
    if (this.integrationErrors[hotelId] === undefined) {
      this.integrationErrors[hotelId] = Object()
    }
    this.integrationErrors[hotelId][name] = value
  }

  getAlarmSummary(hotelId: string): AlarmSummary | null | undefined {
    return this.alarmSummaries()[hotelId]
  }

  private setAlarmSummary(hotelId: string, summary: AlarmSummary | null): void {
    this.alarmSummaries.update((summaries) => ({ ...summaries, [hotelId]: summary }))
  }

  checkAlarmSummary(hotelId: string): Observable<AlarmSummary | null> {
    return this.alarmApiService.Site.getAlarmSummary(hotelId).pipe(
      tap((summary) => {
        this.setAlarmSummary(hotelId, summary)
        this.setTotalErrors(hotelId, "PMS", summary.pmsAlarmEnabled && summary.pmsAlarmDown ? 1 : 0)
        this.setTotalErrors(hotelId, "Key", summary.keyAlarmEnabled && summary.keyAlarmDown ? 1 : 0)
        if (summary.pmsType && this.stateService.selectedHotel?.Id === hotelId) {
          this.stateService.selectedHotel = { ...this.stateService.selectedHotel, PMSName: summary.pmsType }
        }
      }),
      catchError(() => {
        this.setAlarmSummary(hotelId, null)
        this.setTotalErrors(hotelId, "PMS", 0)
        this.setTotalErrors(hotelId, "Key", 0)
        return of(null)
      }),
    )
  }

  //// Site
  // updateSiteHealth(emails: string, subject: string, content: string, forward: boolean): Observable<any> {
  //   return this.authService.getHotelPreference().pipe(
  //     flatMap((hotel) => {
  //       let updateEmails = [emails]
  //       if (emails.includes(",")) {
  //         updateEmails = emails.split(",")
  //       }
  //       const body = {
  //         HotelId: hotel.Id,
  //         Emails: updateEmails.reduce((acc, curVal) => {
  //           return acc.concat(curVal)
  //         }, []),
  //         Subject: subject !== "" ? subject : undefined,
  //         Content: content !== "" ? content : undefined,
  //         IsEnabled: forward,
  //       }
  //       return this.apiService.post(`${API_HOTEL_V2}Health/SiteSoftware/Notification`, body)
  //     }),
  //     tap(
  //       () => {},
  //       () => {}
  //     )
  //   )
  // }

  // fetchSiteHealth(): Observable<any> {
  //   return this.authService.getHotelPreference().pipe(
  //     flatMap((hotel) => this.apiService.get(`${API_HOTEL_V2}Health/SiteSoftware/Notification/${hotel.Id}`)),
  //     tap(
  //       () => {},
  //       () => {}
  //     )
  //   )
  // }

  // fetchSiteHealthStatus(): Observable<any> {
  //   return this.authService.getHotelPreference().pipe(
  //     flatMap((hotel) => {
  //       return this.apiService.get(`${API_HEARTBEAT}Booking/Data/Hotel/${hotel.Id}/Organization/${this.authService.employeeInfo.OrganizationId}/Alert`)
  //     }),
  //     tap(
  //       () => {},
  //       () => {}
  //     )
  //   )
  // }

  // checkSiteHealth(hotelId: string): Observable<{ Success: boolean; Timestamp: string; IsEnabled: boolean }> {
  //   let didRun = false

  //   return this.apiService.get(`${API_HEARTBEAT}Booking/Data/Hotel/${hotelId}/Latest`).pipe(
  //     tap(
  //       (res) => {
  //         didRun = true
  //         if (res.Success === false) {
  //           this.setTotalErrors(hotelId, "Site", 1)
  //         } else {
  //           this.setTotalErrors(hotelId, "Site", 0)
  //         }
  //       },
  //       (err) => {
  //         this.setTotalErrors(hotelId, "Site", 1)
  //       },
  //       () => {}
  //     )
  //   )
  // }

  // createSiteHealthStatus(): Observable<any> {
  //   return this.authService.getHotelPreference().pipe(
  //     flatMap((hotel) => {
  //       return this.apiService.put(`${API_HEARTBEAT}Booking/Data/Hotel/${hotel.Id}/Organization/${this.authService.employeeInfo.OrganizationId}/Alert`)
  //     }),
  //     tap(
  //       () => {},
  //       () => {}
  //     )
  //   )
  // }

  // updateSiteHealthStatus(enabled: boolean): Observable<any> {
  //   return this.authService.getHotelPreference().pipe(
  //     flatMap((hotel) => {
  //       const body = { Enabled: enabled }
  //       return this.apiService.post(`${API_HEARTBEAT}Booking/Data/Hotel/${hotel.Id}/Organization/${this.authService.employeeInfo.OrganizationId}/Alert`, body)
  //     }),
  //     tap(
  //       () => {},
  //       () => {}
  //     )
  //   )
  // }

  sum(obj) {
    return Object.keys(obj).reduce((val, key) => val + parseFloat(obj[key] || 0), 0)
  }
}
